import React, { useCallback, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { Button, Form, Input, InputNumber, Modal, Select } from 'antd';
import moment from 'moment';
import ProductList from './controls/ProductList';
import InstitutionsList from './controls/InstitutionsList';
import DatePickerLocale from '../DatePickerLocale';
import SubdivisionsList from './controls/SubdivisionsList';
import RetailListForReport from '../retail/RetailListForReport';
import { NOMINAL_TABLE_OF_GENERAL_SUBSCRIPTIONS_BY_PERIOD } from '../../services/reports/constants';
import UatList from './controls/uatList';

const FORMATS = ['pdf', 'xlsx', 'csv'];

const ReportWindow = ({ report, onPrint, onClose, buttonDisabled }) => {
  const { t } = useTranslation();
  const [form] = Form.useForm();
  const [currentInstitutionId, setCurrentInstitutionId] = useState();

  useEffect(() => {
    if (report) {
      form.resetFields();
    }
  }, [form, report]);

  const handleFormSubmit = (values) => {
    const formData = {
      ...values,
      TIMEZONE: Intl.DateTimeFormat().resolvedOptions().timeZone,
    };
    onPrint(formData);
  };

  const renderInputControl = useCallback(
    (control) => {
      const disabledStartDate = (current) => {
        const endDate = form.getFieldValue('END');
        return endDate ? current.isAfter(endDate, 'day') : false;
      };

      const disabledEndDate = (current) => {
        const startDate = form.getFieldValue('START');
        return startDate ? current.isBefore(startDate, 'day') : false;
      };

      return (
        <Form.Item
          key={control.parameter}
          label={control.label}
          name={control.parameter}
        >
          {(() => {
            switch (control.type) {
              case 'numeric':
                return <InputNumber />;
              case 'datetime':
                return <DatePickerLocale />;
              case 'date':
                // return control.label === 'START' ? (
                //     <DatePickerLocale disabledDate={disabledStartDate} />
                // ) : (
                //     <DatePickerLocale
                //         disabledDate={disabledEndDate}
                //         defaultValue={moment()}
                //     />
                // );
                // eslint-disable-next-line no-case-declarations
                let content;
                if (control.label === 'START') {
                  content = (
                    <DatePickerLocale disabledDate={disabledStartDate} />
                  );
                } else if (control.label === 'END') {
                  content = <DatePickerLocale disabledDate={disabledEndDate} />;
                } else {
                  content = (
                    <DatePickerLocale
                      disabledDate={disabledEndDate}
                      defaultValue={moment()}
                    />
                  );
                }
                return content;
              case 'text':
                return <Input />;
              case 'Procent_Decontare_90':
                return <InputNumber defaultValue="90" />;
              case 'Procent_Decontare_10':
                return <InputNumber defaultValue="10" />;
              case 'Varsta':
                return <InputNumber defaultValue="30" />;
              case 'products_list':
                return (
                  report.userTypes && (
                    <ProductList
                      userTypesIds={report.userTypes}
                      showOnlyPasses={report.uri.includes(
                        NOMINAL_TABLE_OF_GENERAL_SUBSCRIPTIONS_BY_PERIOD,
                      )}
                    />
                  )
                );
              case 'institutions_list':
                return (
                  report.userTypes && (
                    <InstitutionsList
                      form={form}
                      userTypesIds={report.userTypes}
                      setCurrentInstitutionId={setCurrentInstitutionId}
                    />
                  )
                );
              case 'subdivisions_list':
                return (
                  report.userTypes && (
                    <SubdivisionsList
                      form={form}
                      userTypesIds={report.userTypes}
                      institutionId={currentInstitutionId}
                    />
                  )
                );
              case 'Vanzator':
                return (
                  report.userTypes && (
                    <RetailListForReport userTypesIds={report.userTypes} />
                  )
                );
              case 'uat_list':
                return (
                  report.userTypes && (
                    <UatList form={form} fieldName={control.parameter} />
                  )
                );
              default:
                return <Input />;
            }
          })()}
        </Form.Item>
      );
    },
    [form, report, setCurrentInstitutionId, currentInstitutionId],
  );

  return (
    <Modal
      title={report ? report.label : ''}
      visible={!!report}
      onCancel={onClose}
      footer={[
        <Button key="close" type="primary" onClick={onClose}>
          Cancel
        </Button>,
        <Button
          key="submit"
          type="primary"
          disabled={buttonDisabled}
          onClick={form.submit}
        >
          {t('pages.reports.generate')}
        </Button>,
      ]}
      width={800}
    >
      <Form
        form={form}
        labelCol={{ span: 8 }}
        wrapperCol={{ span: 16 }}
        initialValues={{
          _format: FORMATS[0],
          TIMEZONE: Intl.DateTimeFormat().resolvedOptions().timeZone,
        }}
        onFinish={handleFormSubmit}
        autoComplete="off"
      >
        <Form.Item label="Format" name="_format">
          <Select>
            {FORMATS.map((format) => (
              <Select.Option key={format} value={format}>
                {t(`reports.format.${format}`)}
              </Select.Option>
            ))}
          </Select>
        </Form.Item>

        {report && report.inputControls.map(renderInputControl)}
      </Form>
    </Modal>
  );
};

export default ReportWindow;
